module.exports = __webpack_public_path__ + "img/Button_Stop.54e3ecf1.png";